import { useState, useEffect } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

import * as apiComms from '../apiComms';
import * as logger from '../logger';
import * as dayjs from 'dayjs';

const PROG = 'ChartCollectorCardsCompletedPerDay.js';

const ChartCollectorCardsCompletedPerDay = (props) => {

  const [chartData, setChartData] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    const loadChartData = async () => {
      const FUNCTION = 'loadChartData';

      try {
        setIsLoadingData(true);
        const _chartDataResponse = await apiComms.getChartDataCollectorCardsCompletedPerDay(props.timeRange);
        if (_chartDataResponse && !_chartDataResponse.isErr) {
          setChartData(_parseChartDataDates(_chartDataResponse.response.chartdata));
        }
        setIsLoadingData(false);
      }
      catch (e) {
        logger.error('Exception Occured', { PROG, FUNCTION });
        console.log('Exception: '+e+', '+e.stack);
      }
    };

    loadChartData();
  }, [props.timeRange]);

  const _parseChartDataDates = (_chartData) => {
    return _chartData.map((_chartDataRec) => ({
      date : dayjs(_chartDataRec.x*1000).format('DD/MMM/YYYY'),
      nadur2 : _chartDataRec.nadur2,
      nadur6 : _chartDataRec.nadur6,
      nadur12 : _chartDataRec.nadur12
    }));
  };

  return (
    <div className='card'>
      <div style={{ display : 'flex', width : '100%', flexDirection : 'column', borderRadius: 10, overflow : 'hidden' }} >
        <div style={{ height : 280 }}>
          {!isLoadingData ? (
            <>
            {Array.isArray(chartData) && chartData.length > 0 ? (
            <ResponsiveContainer>
              <LineChart data={chartData} margin={{ top: 20, right: 20, left: 6, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" angle={45} textAnchor="start" height={60} tick={{ fontSize: 10 }} />
                <YAxis width={42} />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="nadur2" stroke="#369fe3" strokeWidth={2} dot={false} name="NADUR-2" />
                <Line type="monotone" dataKey="nadur6" stroke="#20c997" strokeWidth={2} dot={false} name="NADUR-6" />
                <Line type="monotone" dataKey="nadur12" stroke="#f59f00" strokeWidth={2} dot={false} name="NADUR-12" />
              </LineChart>
            </ResponsiveContainer>
            ) : null }
            </>
          ) : null }
        </div>
        <div className='card-body'>
          Collector Cards Completed Per Day
        </div>
      </div>
    </div>
  );
};

export default ChartCollectorCardsCompletedPerDay;
